import { Button } from "reactstrap";
import { isEmpty } from "lodash";
import Cookies from "js-cookie";
import { updateVideoPageState } from "../../Pages/Video/VideoActions";
import { useDispatch, useSelector } from "react-redux";

export const AddVideosBtn = ({ uploadVideoDetails, setUploadVideoModal }) => {
  return (
    // <Button
    //   color="primary"
    //   style={{ background: "white" }}
    //   disabled={isEmpty(uploadVideoDetails)}
    //   onClick={() => setUploadVideoModal(true)}
    // >
    //   Add Videos
    // </Button>

    <div
      className="add-button"
      style={{ cursor: "pointer" }}
      onClick={
        isEmpty(uploadVideoDetails) ? () => {} : () => setUploadVideoModal(true)
      }
    >
      <div>
        <img
          role="button"
          src={require(`@src/assets/images/icons/add-videos-icon.png`).default}
          width={35}
        />
      </div>
      <div>Add Video</div>
    </div>
  );
};

export const CreateCampaign = () => {
  return (
    <a
      // href={`http://localhost:3001?auth=${Cookies.get("jwt")}`}
      href={`https://master.d2kql0c00upys6.amplifyapp.com`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "inherit", textDecoration: "none" }}
    >
      <Button color="primary" style={{ background: "white" }}>
        Create campaign
      </Button>
    </a>
  );
};

export const AddProductBtn = ({ setOpenNewProduct, openNewProduct }) => {
  return (
    <>
      {" "}
      <Button.Ripple
        color="primary"
        onClick={() => setOpenNewProduct(!openNewProduct)}
      >
        Add Product
      </Button.Ripple>
    </>
  );
};

export const PublishToAppBtn = ({
  handleOpenSinglePublish,
  setOpenSinglePublish,
}) => {
  const dispatch = useDispatch();
  const handleClick = () => {
    setOpenSinglePublish(handleOpenSinglePublish);
    dispatch(
      updateVideoPageState({
        publishVideosCheckList: [],
      })
    );
  };

  //isPublished
  const isPublished = useSelector(
    (state) =>
      state.videoAssociations.body?.video?.additional_data?.data
        ?.published_to_swirl === "Successfully updated published status"
  );

  return (
    <div
      className="d-flex align-items-center"
      style={{
        color: "grey",
        opacity: 0.5,
        pointerEvents: "none",
      }}
      onClick={handleClick}
    >
      <div>
        {isPublished ? (
          <img
            style={{ marginBottom: "3px" }}
            role="button"
            src={
              require(`@src/assets/images/vyrill/videos/unpublish-Icon.png`)
                .default
            }
            width={18}
            alt="Publish Icon"
          />
        ) : (
          <img
            role="button"
            src={
              require(`@src/assets/images/vyrill/videos/publishedSwirll.png`)
                .default
            }
            width={18}
            alt="Publish Icon"
          />
        )}
      </div>
      <div style={{ fontSize: "18px", color: "#783AD0", marginLeft: "10px" }}>
        {isPublished ? "Unpublish Video" : "Publish Video"}
      </div>
    </div>
  );
};
